export default function fb(path, method, params) {
  return new Promise((resolve, reject) => {
    FB.api(path, method, params, (res) => {
      if (!res || res.error) {
        reject(res);
      } else {
        resolve(res);
      }
    });
  });
}
